import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import {
  CenterOlPayment,
  CenterOlPaymentFilters
} from '../../lib/types/models/center-ol-payment/center-ol-payment'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getCenterOlPayments(input?: PaginationRequest<CenterOlPaymentFilters>) {
  return restApiClient
    .url(encodeNestedObject(API.centerOlPayments.getAll.url, input))
    .get<PaginationResponse<CenterOlPayment>>()
}
